export class BasicAuthorization {
    id: number;
    userId: number;
    userName: string;
    document: string;
    documentType: string;
    role: string;
    unit: string;
    authorizer: string;
    unitPhoneNumber: string;
    unitIntercomNumber: string;
    authPhoneNumber: string;
    authIntercomNumber: string;
    validPeriodStartsAt: string;
    validPeriodEndsAt: string;
    waitOnLobby: boolean;
    currentBlockade: string;
    userUpdatedAt: string;
    userUpdateStatus: number;
    userUpdateStatusErrorMessage: string;
    userUpdatedPhotoB64At: string;
    lastAccessIn: string;
    lastAccessOut: string;
    status: number;
    roleSubTypeId: number;
}
